<template lang="pug">
.form-sign-contract

  h2 {{ renew_contract ? '续签合同' : '新签合同' }} {{ by_day ? '(日租)' : '' }}

  .ui.button.yellow(@click='init_by_day()', v-if='!renew_contract && !preorder && !by_day') 转换为日租合同

  .ui.icon.warning.message(v-if='current_contract && !current_contract.preorderable && current_contract_days_to_end > 0')
    i.warning.icon
    .content
      .header
        | 当前合同未到期
      p 距离当前合同到期还有 {{current_contract_days_to_end}} 天 ({{$formatters.date.to_date(current_contract.date_end)}})， 请核对信息确认无误后继续操作。

  template(v-if='preorder')
    h3 预约信息
    auto-table(:defines='$defines.preorder', :data='[preorder]', :detail-view='true', layout='detailed_table')
  template(v-if='renew_contract')
    h3 原合同信息
    auto-table(:defines='$defines.contract', unstackable, :data='[renew_contract]', :detail-view='true')

  h3 合同信息
  el-form.ui.form(:model='draft.contract', :rules='rules.contract', ref='formContract')
    .equal.width.fields
      el-form-item.ui.field.required(prop='date_start')
        label 开始日期
        datepicker(v-model='draft.contract.date_start', type='date', placeholder='开始日期', :disabled='!!this.renew_contract')

      el-form-item.ui.field.required(prop='duration_months', v-if='!by_day')
        label 合同时长 (月)
        el-input-number(v-model='draft.contract.duration_months', :min='1')
      el-form-item.ui.field.required(prop='duration_days', v-if='by_day')
        label 合同时长 (日)
        el-input-number(v-model='draft.contract.duration_days', :min='1')

      el-form-item.ui.field.required(prop='date_end')
        label 结束日期
        datepicker(v-model='draft.contract.date_end', type='date', placeholder='结束日期', :min='draft.contract.date_start')

    .equal.width.fields
      el-form-item.ui.field.required(prop='pay_unit_month', v-if='!by_day')
        label 租金支付单位 (月)
        el-input-number(v-model='draft.contract.pay_unit_month', :min='1')
      el-form-item.ui.field.required(prop='price_month', v-if='!by_day')
        label 租金 / 月
        el-input-number(v-model='draft.contract.price_month', :min='0', :controls='false')

      el-form-item.ui.field.required(prop='price_day', v-if='by_day')
        label 租金 / 日
        el-input-number(v-model='draft.contract.price_day', :min='0', :controls='false')

      el-form-item.ui.field.required(prop='deposit_money')
        label 合同押金
        el-input-number(v-model='draft.contract.deposit_money', :min='0', :controls='false', :disabled='renew_contract')

      template(v-if='!by_day')
        el-form-item.ui.field.required(prop='management_fee_month')
          label 管理费 / 月
          el-input-number(v-model='draft.contract.management_fee_month', :min='0', :controls='false')
        el-form-item.ui.field.required(prop='network_fee_month')
          label 网络费 / 月
          el-input-number(v-model='draft.contract.network_fee_month', :min='0', :controls='false')

      template(v-else)
        el-form-item.ui.field.required(prop='cleaning_fee')
          label 清洁费
          el-input-number(v-model='draft.contract.cleaning_fee', :min='0', :controls='false')

  h3 首期租金
  el-form.ui.form(:model='draft.rent', :rules='rules.rent', ref='formRent')
    .equal.width.fields
      el-form-item.ui.field.required
        label 租金开始日期
        datepicker(v-model='draft.contract.date_start', type='date', placeholder='开始日期', disabled)

      el-form-item.ui.field.required(prop='rent_month', v-if='!by_day')
        label 时长 (月)
        el-input-number(v-model='draft.rent.rent_month', :min='0')
      el-form-item.ui.field.required(prop='rent_day', v-if='by_day')
        label 时长 (日)
        el-input-number(v-model='draft.rent.rent_day', :min='0', disabled)

      el-form-item.ui.field.required(prop='date_end')
        label 租金结束日期
        datepicker(v-model='draft.rent.date_end', type='date', placeholder='结束日期', :disabled='by_day')

      el-form-item.ui.field.required(prop='amount_paid')
        label 租金总额
        el-input-number(v-model='draft.rent.amount_paid', :min='0', :controls='false')

  template(v-if='$permission.has("basic.create.contracts.discount") && !by_day')
    h3 优惠策略
    .ui.field
      .ui.button.orange(@click='discount_management')
        | 免除1个月管理费
      .ui.button.orange(@click='discount_rent')
        | 免除1个月租金
      .ui.button.grey(@click='discount_reset')
        | 重置优惠

  h3 住户信息
  .ui.field
    form-customers(:customers='draft.customers', ref='customers')

  h3 其他
  el-form.ui.form
    .two.fields
      .field
        label 其他费用
        input(v-model='draft.contract.other_fee_note')
      .field
        label 其他费用金额
        el-input-number(v-model='draft.contract.other_fee', :min='0', :controls='false')
    .ui.field
      label 合同补充
      textarea(v-model='draft.contract.additions', rows='1')
    .ui.field
      label 备注
      textarea(v-model='draft.contract.note', rows='2')

  h3
  .ui.grid.two.columns.stackable(v-if='!this.renew_contract')
    .column
      h3.with-actions
        span 物品清单
        .ui.buttons.actions
          .ui.basic.icon.button(@click='dialog_properties = true')
            i.icon.pencil.themed.text
          .ui.basic.icon.button(@click='print_properties')
            i.icon.print.themed.text
      room-properties(:properties='draft.properties')
      dialog-edit-properties(:properties.sync='draft.properties', :visible.sync='dialog_properties', @exit='dialog_properties = false')

    .column
      el-checkbox(v-model='draft.pay_for_utilities', v-if='!$config.logic.manual_meter' label='预充值水电费')
      br
      br
      h3.with-actions
        span 水电表信息
        .actions.ui.tiny.buttons
          .ui.basic.button.icon(@click='dialog_utilities = true')
            i.pencil.icon.themed.text
      utility-view(v-for='(utility, index) in room.utilities', :paid='room.utilities_paid' :key='index', :data='utility')
      el-dialog(:visible.sync='dialog_utilities', size='large')
        template(v-if='dialog_utilities')
          form-utilities(:no='no', :indialog='true', @exit='dialog_utilities = false')

  h3 费用清单
  .ui.form
    .ui.field
      receipts(:receipts='receipts')

    .ui.field
      label 支付方式
      payment-method-select(v-model='draft.payment_method')

    .ui.field
      br
      el-checkbox.inline(v-model='if_print_properties') 生成物品清单
      el-checkbox.inline(v-if='draft.pay_for_utilities', v-model='if_print_utilities') 生成水电费单

    .ui.field.actions
      template(v-if='$permission.has("basic.create.contract.print_ahead") && false')
        .ui.button.icon.labeled.blue(v-if='draft.pay_for_utilities', @click='print_utilities')
          i.icon.print
          | 生成水电费单
        .ui.button.icon.labeled.blue(@click='print_properties')
          i.icon.print
          | 生成物品清单
        .ui.button.icon.labeled.teal(@click='print_draft')
          i.icon.print
          | 生成合同
      .ui.button.themed.icon.labeled(@click='stage_finish')
        i.icon.checkmark
        | 完成签署
      .ui.button.icon(@click='draft_save')
        i.icon.save
      .ui.button.icon(@click='draft_remove')
        i.icon.trash
</template>

<script>
import { MakeForm } from '../../utils'
import { MixPage, MixDraft } from '../../mixins'

import { AutoTable } from '../auto'
import { PaymentMethodSelect, Receipts, UtilityView, Datepicker } from '../basic'
import RoomProperties from '../mixed/RoomProperties.vue'
import DialogEditProperties from './DialogEditProperties.vue'
import FormCustomers from './FormCustomers.vue'
import FormUtilities from './FormUtilities.vue'

export default {
  name: 'form-sign-contract',
  components: {
    AutoTable,
    DialogEditProperties,
    FormUtilities,
    PaymentMethodSelect,
    Receipts,
    RoomProperties,
    UtilityView,
    FormCustomers,
    Datepicker,
  },
  props: ['no', 'preorder_id', 'load_draft_key', 'renew_contract_id'],
  data() {
    return {
      draft: {
        _room: null,
        payment_method: 'cash',
        contract: {
          date_start: this.$moment().add(1, 'days').startOf('day'),
          date_end: this.$moment().add(1, 'years').startOf('day'),
          rent_by_day: false,
          duration_months: 3,
          duration_days: 0,
          price_month: 99999,
          price_day: 0,
          pay_unit_month: 3,
          management_fee_month: 50,
          network_fee_month: 0,
          deposit_money: 2000,
          cleaning_fee: 0,
          other_fee: 0,
          other_fee_note: '',
          note: '',
          additions: '',
          // mutiple_rooms: false,
          _extra_rooms: null,
        },
        rent: {
          date_start: this.$moment().add(1, 'days').startOf('day'),
          date_end: this.$moment().add(3, 'months').startOf('day'),
          rent_month: 3,
          rent_day: 0,
          price_month: 99999,
          price_day: 0,
          amount_paid: 99999,
          amount_due: 99999,
          management_fee: 0,
          management_fee_month: 50,
          network_fee_month: 0,
          network_fee: 0,
          state: 'paid',
          rent_by_day: false,
        },
        customers: [{}],
        properties: [],

        pay_for_utilities: false,
      },

      discount: {
        rent_month: 0,
        management_month: 0,
        network_month: 0,
        price_month_multiplier: 1,
      },

      rules: {
        contract: {
          date_start: [{ required: true, message: '请选择开始日期' }],
          date_end: [{ required: true, message: '请选择结束日期' }],
        },
        rent: {},
      },

      if_print_properties: true,
      if_print_utilities: true,
      dialog_utilities: false,
      dialog_properties: false,
      draft_key: null,
    }
  },
  computed: {
    room() {
      return this.$store.getters.room(this.no)
    },
    preorder() {
      return this.$store.getters.preorder(this.preorder_id || this.draft.contract._preorder)
    },
    renew_contract() {
      if (this.renew_contract_id)
        return this.$store.getters.contract(this.renew_contract_id)
      return null
    },
    current_contract() {
      return this.$store.getters.current_contract_of_room(this.no)
    },
    current_contract_days_to_end() {
      if (this.current_contract) {
        const end_date = this.$moment(this.current_contract.date_end)
        const now = this.$moment().utc().startOf('day')
        return this.$moment.daysBetween(end_date, now)
      }
      return 0
    },
    by_day() {
      return this.draft.contract.rent_by_day
    },
    receipts() {
      const receipts = [{
        name: '合同押金',
        price: this.draft.contract.deposit_money,
      }]

      if (this.by_day) {
        receipts.push({
          name: '日租租金',
          unit: ' 日',
          quantity: this.draft.rent.rent_day,
          unit_price: this.draft.contract.price_day,
          price: this.draft.rent.amount_paid,
        })
        receipts.push({
          name: '清洁费',
          price: this.draft.contract.cleaning_fee,
        })
      } else {
        receipts.push({
          name: '首期租金',
          unit: ' 个月',
          quantity: this.draft.rent.rent_month + this.discount.rent_month,
          unit_note: this.discount.rent_month !== 0 ? `优惠${-this.discount.rent_month}个月` : undefined,
          unit_price: this.draft.contract.price_month,
          price: this.draft.rent.amount_paid,
        })
        receipts.push({
          name: '管理费',
          unit: ' 个月',
          quantity: this.draft.rent.rent_month + this.discount.management_month,
          unit_note: this.discount.management_month !== 0 ? `优惠${-this.discount.management_month}个月` : undefined,
          unit_price: this.draft.contract.management_fee_month,
          price: this.draft.rent.management_fee,
        })
        receipts.push({
          name: '网络费',
          unit: ' 个月',
          quantity: this.draft.rent.rent_month,
          unit_price: this.draft.contract.network_fee_month,
        })
      }

      if (this.draft.contract.other_fee) {
        receipts.push({
          name: `其他费用: ${this.draft.contract.other_fee_note || '-'}`,
          unit_price: this.draft.contract.other_fee,
        })
      }

      if (this.draft.pay_for_utilities) {
        for (const utility of this.room.utilities) {
          receipts.push({
            name: this.$formatters.utility_label(utility.type),
            unit: this.$formatters.utility_unit(utility.type),
            unit_price: this.$formatters.utility_price(utility.type),
            quantity: utility.balance,
          })
        }
      }

      return receipts
    },
  },
  mixins: [
    MixPage,
    MixDraft({
      type: 'contracts',
      field: 'draft',
      loadOnMounted: false,
    }),
  ],
  created() {
    let initialized = false
    if (!this.room) {
      this.$router.replace('/404')
      return
    }

    if (this.load_draft_key) {
      this.draft_key = this.load_draft_key
      initialized = this.draft_load()
      if (!initialized)
        this.$router.push('..')
    }

    if (!initialized) {
      // init
      this.draft_key_generate()
      this.init_data()
    }
  },
  watch: {
    'draft.contract.date_start': function () {
      this.contract_date_update()
      this.draft.rent.date_start = this.draft.contract.date_start
      this.rent_date_update()
    },
    'draft.contract.duration_months': function () {
      this.contract_date_update()
      this.rent_date_update()
      this.draft.contract.pay_unit_month = Math.min(this.draft.contract.pay_unit_month, this.draft.contract.duration_months)
    },
    'draft.contract.duration_days': function () {
      this.contract_date_update()
      this.rent_date_update()
      this.rent_price_update()
    },
    'draft.contract.pay_unit_month': function () {
      this.draft.rent.rent_month = this.draft.contract.pay_unit_month
    },
    'draft.contract.price_month': function () {
      this.rent_price_update()
    },
    'draft.contract.price_day': function () {
      this.rent_price_update()
    },
    'draft.contract.management_fee_month': function () {
      this.rent_price_update()
    },
    'draft.contract.network_fee_month': function () {
      this.rent_price_update()
    },
    'draft.rent.rent_month': function () {
      this.rent_date_update()
      this.rent_price_update()
    },
    'draft.pay_for_utilities': function () {
      this.draft.utilities = this.room.utilities
    },
    discount: {
      deep: true,
      handler() {
        this.rent_date_update()
        this.rent_price_update()
      },
    },
  },
  methods: {
    init_data() {
      this.draft._room = this.room._id
      this.draft.contract.price_month = this.room.price_month
      this.draft.contract.deposit_money = Math.max(2000, this.room.price_month)
      this.draft.properties = (this.room.properties || []).map(item => Object.assign({}, item))

      if (this.renew_contract) {
        this.draft.contract._previous_contract = this.renew_contract_id
        this.draft.contract.duration_months = this.renew_contract.duration_months
        this.draft.contract.date_start = this.$moment(this.renew_contract.date_expire).add(1, 'days')
        this.draft.contract.pay_unit_month = this.renew_contract.pay_unit_month
        this.draft.contract.price_month = this.renew_contract.price_month
        this.draft.contract.management_fee_month = this.renew_contract.management_fee_month
        this.draft.contract.network_fee_month = this.renew_contract.network_fee_month
        this.draft.contract.deposit_money = 0
        this.draft.contract.note = '续签合同;'
        this.if_print_properties = false
        this.draft.pay_for_utilities = false

        this.draft.customers = this.$store.getters.customers_filter(this.renew_contract._customers)
      } else if (this.preorder) {
        this.draft.contract._preorder = this.preorder_id
        this.draft.contract.duration_months = this.preorder.duration_months
        this.draft.contract.duration_months = this.preorder.duration_months
        this.draft.contract.date_start = this.$moment(this.preorder.date_start)
        this.draft.contract.date_end = this.$moment(this.preorder.date_end)
        this.draft.contract.pay_unit_month = this.preorder.pay_unit_month

        this.draft.customers[0].name = this.preorder.customer_name
        this.draft.customers[0].phone1 = this.preorder.customer_phone
        this.draft.customers[0].idcard = this.preorder.customer_idcard
      }

      this.contract_date_update()
      this.rent_date_update()
      this.rent_price_update()
    },
    init_by_day() {
      this.draft.contract.rent_by_day = true
      this.draft.contract.deposit_money = 0
      this.draft.contract.pay_unit_month = 0
      this.draft.contract.price_month = 0
      this.draft.contract.price_day = Math.ceil((this.room.price_month / 30) / 5) * 5
      this.draft.contract.management_fee_month = 0
      this.draft.contract.network_fee_month = 0
      this.draft.contract.duration_months = 0
      this.draft.contract.duration_days = 10
      this.draft.contract.cleaning_fee = 50
      this.draft.rent.rent_by_day = true

      this.contract_date_update()
      this.rent_date_update()
      this.rent_price_update()
    },
    submit_form: MakeForm({
      type: 'post',
      url: 'contracts/new',
      confirm: '确定签署合同？',
      payload() {
        const payload = this.draft
        if (this.draft.pay_for_utilities) {
          payload.utilities = this.room.utilities.map(({ type, balance, ...others }) => ({
            type,
            quantity: balance,
            unit_price: this.$formatters.utility_price(type) || 0,
            ...others,
          }))
        }

        // TODO: Discount
        return payload
      },
      $afterSuccess(body) {
        this.print_draft(body.data.contract)
        if (this.if_print_properties)
          this.print_properties()
        if (this.draft.pay_for_utilities && this.if_print_utilities)
          this.print_utilities()
        this.$store.dispatch('load_summary', this)
        const id = body.data.contract._id
        if (id)
          this.$router.$go.contract({ room_no: this.no, id })
        else
          this.$router.back()
      },
    }),
    form_validate() {
      const promises = [new Promise((resolve, reject) => {
        this.$refs.formContract.validate((valid) => {
          if (valid) resolve(valid)
          else reject(valid)
        })
      })]
      promises.push(this.$refs.customers.form_validate())
      return Promise.all(promises)
    },
    stage_finish() {
      this.form_validate().then(() => {
        this.submit_form()
      }).catch(e => {
        console.error(e)
        this.page_scroll_to(document.body, 100, 800)
      })
    },
    contract_date_update() {
      if (this.by_day) {
        this.draft.contract.date_end = this.$moment(this.draft.contract.date_start)
          .add(this.draft.contract.duration_days, 'days')
          .toDate()
      } else {
        this.draft.contract.date_end = this.$moment(this.draft.contract.date_start)
          .add(this.draft.contract.duration_months, 'months')
          .subtract(1, 'days')
          .toDate()
      }
    },
    rent_date_update() {
      if (this.by_day)
        this.draft.rent.date_end = this.draft.contract.date_end
      else {
        this.draft.rent.date_end = this.$moment(this.draft.rent.date_start)
          .add(this.draft.rent.rent_month, 'months')
          .subtract(1, 'days')
          .toDate()
      }
    },
    rent_price_update() {
      this.draft.rent.price_month = this.draft.contract.price_month
      this.draft.rent.price_day = this.draft.contract.price_month
      this.draft.rent.amount_due = this.draft.contract.price_month * (this.draft.rent.rent_month + this.discount.rent_month)
      this.draft.rent.amount_paid = this.draft.rent.amount_due
      this.draft.rent.management_fee = this.draft.contract.management_fee_month * (this.draft.rent.rent_month + this.discount.management_month)
      this.draft.rent.network_fee = this.draft.contract.network_fee_month * (this.draft.rent.rent_month + this.discount.network_month)
      this.draft.rent.management_fee_month = this.draft.contract.management_fee_month
      this.draft.rent.network_fee_month = this.draft.contract.network_fee_month

      if (this.by_day) {
        this.draft.rent.rent_day = this.draft.contract.duration_days
        this.draft.rent.amount_due = this.draft.contract.price_day * this.draft.rent.rent_day
        this.draft.rent.amount_paid = this.draft.rent.amount_due
      }
    },
    print_draft(contract) {
      const obj = {
        room: this.room,
        $methods: this.$store.state.summary.payment_methods,
        renew: !!this.renew_contract_id,
        ...this.draft,
        contract,
      }
      if (this.by_day)
        this.$templater.request('contract_by_day', obj)
      else
        this.$templater.request('contract', obj)
    },
    print_properties() {
      this.$templater.request('properties', {
        room: this.room,
        properties: this.$store.getters.properties_of_room(this.draft.properties),
      })
    },
    print_utilities() {
      this.$templater.request('charge', {
        room: this.room,
        utilities: this.room.utilities.map(u => ({
          type: u.type,
          unit_price: this.$formatters.utility_price(u.type),
          quantity: u.balance,
        })),
        customers: this.draft.customers,
        payment_method: this.draft.payment_method,
        $methods: this.$store.state.summary.payment_methods,
        note: '首次充值',
      })
    },
    discount_management() {
      this.discount.management_month -= 1
      this.draft.contract.note += '\n优惠方案: 免除1个月管理费'
    },
    discount_rent() {
      this.discount.rent_month -= 1
      this.draft.contract.note += '\n优惠方案: 免除1个租金'
    },
    discount_reset() {
      this.discount.rent_month = 0
      this.discount.management_month = 0
    },
  },
}
</script>



// WEBPACK FOOTER //
// FormSignContract.vue?d1de4062